import classNames from "classnames";
import { joinHyphenCase } from "neetocommons/utils/general";
import { Typography } from "neetoui";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import MoreDropdown from "components/MoreDropdown";

import OverflowLinks from "./OverflowLinks";

const NavigationLinks = ({ headerLinks, maxVisibleLinks = 5 }) => {
  const visibleLinks = headerLinks.slice(0, maxVisibleLinks);
  const overflowLinks = headerLinks.slice(maxVisibleLinks);

  return (
    <div
      className="font- flex w-full items-center justify-between gap-4 md:justify-center md:gap-3 lg:gap-6"
      data-testid="navigation-header-navigation-links"
    >
      {visibleLinks.map(
        ({
          className = "",
          key,
          label,
          disabled,
          labelProps,
          moreOptions,
          ...rest
        }) => (
          <NavLink
            activeClassName="active"
            data-testid={`${joinHyphenCase(key)}-tab`}
            key={key}
            className={classNames(
              "neeto-molecules-navigation-header__link whitespace-nowrap px-2 capitalize no-underline md:px-0",
              className,
              { disabled }
            )}
            onClick={e => disabled && e.preventDefault()}
            {...rest}
          >
            <Typography
              component="span"
              lineHeight="normal"
              style="h4"
              weight="semibold"
              {...(labelProps || {})}
            >
              {label}
            </Typography>
            {/*
            TODO: In future, render this MoreDropdown only for Active links
            Ref: https://github.com/neetozone/neeto-molecules/issues/2610
            */}
            {moreOptions && <MoreDropdown {...moreOptions} />}
          </NavLink>
        )
      )}
      <OverflowLinks {...{ overflowLinks }} />
    </div>
  );
};

NavigationLinks.propTypes = {
  /**
   * Links to be rendered in the center of the navigation header. It is an array of objects.
   * Each object should have the properties `key`, `to` and `label`. Other props will be passed on to the `Navlink` component from
  `react-router-dom`.
   */
  headerLinks: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      to: PropTypes.string,
      label: PropTypes.string,
      className: PropTypes.string,
      labelProps: PropTypes.shape({ lineHeight: PropTypes.string }),
      moreOptions: PropTypes.shape({
        isVertical: PropTypes.bool,
        dropdownButtonProps: PropTypes.shape({
          size: PropTypes.string,
          className: PropTypes.string,
        }),
        menuItems: PropTypes.arrayOf(
          PropTypes.shape({
            key: PropTypes.string,
            label: PropTypes.string,
            onClick: PropTypes.func,
            disabled: PropTypes.bool,
            isDisabled: PropTypes.bool,
            tooltipProps: PropTypes.shape({
              content: PropTypes.string,
            }),
          })
        ),
      }),
    })
  ),
  /**
   * Maximum number of links to be visible in the navigation header. Remaining links will be shown in a more dropdown.
   */
  maxVisibleLinks: PropTypes.number,
};

export default NavigationLinks;
